import { useMsal } from '@azure/msal-react';

export const useGetProfilePic = () => {
  const { accounts, instance } = useMsal();

  const getProfilePic = async (): Promise<string | undefined> => {
    try {
      const silentResult = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: accounts[0],
      });

      const response = await fetch(
        'https://graph.microsoft.com/v1.0/me/photo/$value',
        {
          headers: {
            Authorization: `Bearer ${silentResult.accessToken}`,
          },
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        return URL.createObjectURL(blob);
      } else {
        return undefined;
      }
    } catch {
      return undefined;
    }
  };

  return { getProfilePic };
};
